(function() {
  'use strict';

  var CHAR_LIMIT = 100;
  var CHECK_INTERVAL = 500;
  var MAX_ATTEMPTS = 40;

  var attempts = 0;
  var processed = false;

  function createShowMore(labelElement) {
    if (processed || labelElement.dataset.showMoreProcessed === 'true') {
      return;
    }

    var allSpans = labelElement.querySelectorAll('span');
    var targetElement = null;
    var fullText = '';

    var directText = Array.from(labelElement.childNodes)
      .filter(function(node) { return node.nodeType === Node.TEXT_NODE; })
      .map(function(node) { return node.textContent.trim(); })
      .join(' ');

    if (directText.length > CHAR_LIMIT) {
      fullText = directText;
      targetElement = labelElement;
    } else {
      for (var i = 0; i < allSpans.length; i++) {
        var spanText = allSpans[i].textContent.trim();
        if (spanText.length > CHAR_LIMIT) {
          targetElement = allSpans[i];
          fullText = spanText;
          break;
        }
      }
    }

    if (!targetElement || !fullText) {
      return;
    }

    processed = true;
    labelElement.dataset.showMoreProcessed = 'true';

    var truncatedText = fullText.substring(0, CHAR_LIMIT) + '...';

    var container = document.createElement('span');
    container.style.display = 'inline';

    var textSpan = document.createElement('span');
    textSpan.textContent = truncatedText;

    var toggleLink = document.createElement('a');
    toggleLink.href = 'javascript:void(0)';
    toggleLink.style.cssText = 'color: #0066cc; text-decoration: underline; margin-left: 5px; cursor: pointer; font-weight: normal;';
    toggleLink.textContent = 'Show more';
    toggleLink.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    if (targetElement === labelElement) {
      var checkbox = labelElement.querySelector('input[type="checkbox"]');
      labelElement.innerHTML = '';
      if (checkbox) {
        labelElement.appendChild(checkbox);
      }
      labelElement.appendChild(container);
    } else {
      targetElement.innerHTML = '';
      targetElement.appendChild(container);
    }

    container.appendChild(textSpan);
    container.appendChild(toggleLink);

    var isExpanded = false;
    toggleLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (isExpanded) {
        textSpan.textContent = truncatedText;
        toggleLink.textContent = 'Show more';
      } else {
        textSpan.textContent = fullText + ' ';
        toggleLink.textContent = 'Show less';
      }

      isExpanded = !isExpanded;
      return false;
    });
  }

  function findAndProcessLabel() {
    var selectors = [
      'label[for="effectiveAppsAgreeCB"]',
      'label[for*="agree"]',
      '#effectiveAppsAgreeCB + label',
      'label:has(#effectiveAppsAgreeCB)',
      '.consent-checkbox label',
      '.agreement-checkbox label'
    ];

    for (var i = 0; i < selectors.length; i++) {
      try {
        var label = document.querySelector(selectors[i]);
        if (label) {
          createShowMore(label);
          return true;
        }
      } catch (e) {
        // Some selectors might not be supported
      }
    }

    var input = document.getElementById('effectiveAppsAgreeCB');
    if (input) {
      var label = input.closest('label') ||
        (input.parentElement ? input.parentElement.querySelector('label') : null) ||
        document.querySelector('label[for="effectiveAppsAgreeCB"]');
      if (label) {
        createShowMore(label);
        return true;
      }
    }

    return false;
  }

  function init() {
    if (findAndProcessLabel()) {
      return;
    }

    var observer = new MutationObserver(function() {
      if (findAndProcessLabel()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true
    });

    var intervalId = setInterval(function() {
      attempts++;

      if (findAndProcessLabel() || attempts >= MAX_ATTEMPTS) {
        clearInterval(intervalId);
        observer.disconnect();
      }
    }, CHECK_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
